<template>
  <div
    :class="[
      {
        'page-has-left-panels page-has-right-panels':
          Object.keys(user).length !== 0,
      },
    ]"
  >
    <SPreloader />
    <SLandingTopBar v-if="Object.keys(user).length === 0" />
    <SubHeaderCategories :categories="categories" pageName="Search" />
    <div class="header-spacer"></div>
    <div class="container">
      <div class="bookmark-banner" :class="{'banner-expand': this.isBannerExpanded}">
        <p class="bookmark-title">Congratulations!</p>
        <p class="bookmark-header-text"> You've found our very first Swampum bookmark!</p>
        <p class="bookmark-text">Register for free and receive 1,000 bonus points to use on Swampum, an online community for sharing things you no longer need and finding things you want.</p>
        <p class="bookmark-text">And follow the steps below to earn MORE bonus points!</p>
        <SButtonMaterial
          class="register-button"
          buttonType="button"
          textColor="white"
          size="lg"
          color="primary"
          materialClass="dense"
          text="Join our community"
          to="/signup"
        />
        <div @click="expand()" v-if="!this.isBannerExpanded" class="mt-2 show-more-dropdown">Find out more about how to earn points</div>
        <div v-if="this.isBannerExpanded" class="mt-2 show-more-box" id="show-more-text">
          <div class="text-blocks">
            <p>You can earn more bonus points by following these steps:</p>
            <p>1. Register for your FREE user account and post a book you want to give</p>
            <p>2. Send us a picture of your bookmark - with you or one of your favorite books</p>
            <p>3. Complete your first transaction: send a book to or receive a book from another user</p>
          </div>
          <div class="text-blocks">
            <p>The first 200 users to complete these three steps will receive an additional 1,000 bonus 
              points. And the VERY FIRST to complete the above will receive an additional 10,000 bonus points! Good luck!
            </p>
          </div>
          <div class="text-blocks">
            <p>Terms: 1. Bookmark pictures must be sent from the email address associated with your registered account to <span class="link-text">socialmedia@swampum.com.</span></p>
            <p>2. User consents to allow Swampum to use the submitted pictures for promotional purposes.</p>
            <p>3. A user may have only one Swampum account and receive one bookmark point bonus. Each bookmark may be used only once for a bonus point award.</p>
          </div>
        </div>
        <div @click="retract()" v-if="this.isBannerExpanded" class="show-more-dropdown">Show less</div>
      </div>
      <div class="row">
        <div
          class="col col-xl-12 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12 card-search-container"
          data-cy="divSearchResults"
        >
          <SShowResultBookmark :count="this.resultNumber" :total="this.totalBooksResults.data.length" :categories="this.selectedCategories" />
          <SFilterBar
            class="ml-2 display-none"
            @button="makeSearch"
            @categoryButton="changeCategory"
            @clearFilter="clearFilter"
            @removeFilter="removeFilter"
            :options="options"
            :choice="choice"
            :optionsType="optionsType"
            :optionsPrivacy="optionsPrivacy"
            :optionsCategory="optionsCategory"
            :optionsCondition="optionsCondition"
            :optionsSort="optionsSort"
            :startWith="startOption"
            :selectedFilters="selectedFilters"
            :startCategory="startCategory"
            ref="sfilter"
          />
          <SLazyContent
            v-if="isSearching"
            :numberOfItems="3"
            data-cy="fetchingResults"
          />
          <div id="search-item-gallery">
            <div
              v-for="(result, index) in this.booksResults"
              class="md-layout-item"
              :key="index"
            >
              <SNewItemMaterial
                :item="result"
                @openWindowPopup="openChat(result)"
                :class="{
                  'item-unavailable':
                    result.status === itemStatus.RECEIVED ||
                    result.status === itemStatus.SENT,
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      id="result-warning"
      buttonName="OK"
      :title="warningTitle"
      ref="modal"
      @button="closeModal()"
      class="font-weight-bold"
      >{{ warning }}</Modal
    >

    <CookiesAndPrivacy
      v-if="!storageCookies && Object.keys(user).length === 0"
      @cookies-privacy="accept"
    />
  </div>
</template>

<script>
import SShowResultBookmark from "@/components/atoms/SShowResultBookmark";
import SFilterBar from "@/components/molecules/SFilterBar";
import Modal from "@/components/atoms/Modal";
import item_status from "@/enum/item-status";
import { mapGetters, mapActions } from "vuex";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SubHeaderCategories from "@/material-components/molecules/SubHeaderCategories.vue";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SLazyContent from "@/material-components/organisms/SLazyContent";
import UserHelper from "@/mixins/UserHelper.vue";
import axios from 'axios';
import Global from '../../constants/Global';

const headers = {
  'Content-Type': 'application/json'
};

export default {
  name: "BookmarkPage",
  mixins: [ChatHelperVue, ItemHelperVue, UserHelper],
  components: {
    SShowResultBookmark,
    SButtonMaterial,
    SFilterBar,
    Modal,
    SPreloader,
    SLandingTopBar,
    SubHeaderCategories,
    SNewItemMaterial,
    CookiesAndPrivacy,
    SLazyContent,
  },
  data() {
    return {
      isBottom: false,
      searchOffset: 48,
      booksResults: [],
      totalBooksResults: [],
      selectedCategories: ["Books"],
      resultNumber: 0,
      prevRoute: null,
      isSearching: false,
      canRedirect: false,
      redirectTo: null,
      itemStatus: item_status,
      selectedKeyChat: {},
      isBannerExpanded: false,
      filter: {
        options: ["","item"],
        itemType: [],
        itemCondition: [],
        itemSort: [],
        privacy: [],
        itemCategory: ["",8],
      },
      selectedItemChat: null,
      warning: null,
      warningTitle: null,
      startOption: [],
      startCategory: [],
      options: [
        { label: "Item", value: "item", dataCy: "itemOption" },
        { label: "Group", value: "group", dataCy: "groupOption" },
        { label: "User", value: "user", dataCy: "userOption" },
      ],
      choice: {
        options: ["","item"],
        itemType: [],
        itemCondition: [],
        itemSort: [],
        privacy: [],
        itemCategory: ["",8],
      },
      optionsType: [
        { value: 1, label: "Give", dataCy: "giveTrade" },
        { value: 2, label: "Receive", dataCy: "receiveTrade" },
        { value: 3, label: "Lend", dataCy: "lendTrade" },
        { value: 4, label: "Borrow", dataCy: "borrowTrade" },
      ],
      optionsPrivacy: [
        { value: 1, label: "Public", dataCy: "publicPrivacy" },
        { value: 2, label: "Private", dataCy: "privatePrivacy" },
      ],
      optionsCondition: [
        { value: 1, label: "New", dataCy: "newCondition" },
        { value: 2, label: "Like New", dataCy: "likeNewCondition" },
        { value: 3, label: "Used", dataCy: "usedCondition" },
        { value: 4, label: "Worn", dataCy: "wornCondition" },
      ],
      optionsSort: [
        { value: 1, label: "New to old", dataCy: "newOldSort" },
        { value: 2, label: "Old to new", dataCy: "oldNewSort" },
        { value: 3, label: "A-Z", dataCy: "aZSort" },
        { value: 4, label: "Z-A", dataCy: "zASort" },
      ],
      optionsCategory: [
        { value: 8, label: "Book", icon: "book", dataCy: "bookCategory" },
        {
          value: 5,
          label: "Auto",
          icon: "directions_car",
          dataCy: "autoCategory",
        },
        {
          value: 3,
          label: "Clothing",
          icon: "checkroom",
          dataCy: "clothingCategory",
        },
        {
          value: 2,
          label: "Electronics",
          icon: "phone_android",
          dataCy: "electronicCategory",
        },
        {
          value: 9,
          label: "Family",
          icon: "child_friendly",
          dataCy: "familyCategory",
        },
        {
          value: 10,
          label: "Games",
          icon: "sports_esports",
          dataCy: "gamesCategory",
        },
        {
          value: 1,
          label: "Household",
          icon: "maps_home_work",
          dataCy: "householdCategory",
        },
        {
          value: 4,
          label: "Music",
          icon: "library_music",
          dataCy: "musicCategory",
        },
        {
          value: 11,
          label: "Sports",
          icon: "sports_football",
          dataCy: "sportsCategory",
        },
        { value: 12, label: "Tools", icon: "build", dataCy: "toolsCategory" },
        { value: 6, label: "Video", icon: "duo", dataCy: "videoCategory" },
        {
          value: 7,
          label: "Other",
          icon: "more_horiz",
          dataCy: "otherCategory",
        },
      ],
      categories: [
        {
          name: "Free",
          icon: "sell",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/free?filter=13",
        },
        {
          name: "Book",
          icon: "book",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/book?filter=8",
        },
        {
          name: "Auto",
          icon: "directions_car",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/auto?filter=5",
        },
        {
          name: "Clothing",
          icon: "checkroom",
          iconClass: "material-icons clothing-class",
          searchQuery: "/s-app/search-result/clothing?filter=3",
        },
        {
          name: "Electronics",
          icon: "phone_android",
          iconClass: "material-icons electronic-class",
          searchQuery: "/s-app/search-result/electronic?filter=2",
        },
        {
          name: "Family",
          icon: "child_friendly",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/family?filter=9",
        },
        {
          name: "Games",
          icon: "sports_esports",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/games?filter=10",
        },
        {
          name: "HouseHold",
          icon: "maps_home_work",
          iconClass: "material-icons-outlined household-class",
          searchQuery: "/s-app/search-result/household?filter=1",
        },
        {
          name: "Music",
          icon: "library_music",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/music?filter=4",
        },
        {
          name: "Sports",
          icon: "sports_football",
          iconClass: "material-icons-outlined",
          searchQuery: "/s-app/search-result/sports?filter=11",
        },
        {
          name: "Tools",
          icon: "build",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/tools?filter=12",
        },
        {
          name: "Video",
          icon: "duo",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/video?filter=6",
        },
        {
          name: "Other",
          icon: "more_horiz",
          iconClass: "material-icons",
          searchQuery: "/s-app/search-result/other?filter=7",
        },
      ],
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
    };
  },
  computed: {
    ...mapGetters({
      searchResult: "getSearchResult",
    }),
    selectedFilters() {
      let filters = [];
      //TO DO: resolver lint
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.selectedCategories = [];
      this.options.forEach((filter) => {
        if (this.choice.options.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.optionsCategory.forEach((filter) => {
        if (
          this.choice.itemCategory.includes(filter.value) &&
          filter.value !== ""
        ){
          filters.push(filter);
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.selectedCategories.push(filter.label);
        }
      });
      this.optionsCondition.forEach((filter) => {
        if (
          this.choice.itemCondition.includes(filter.value) &&
          filter.value !== ""
        )
          filters.push(filter);
      });
      this.optionsSort.forEach((filter) => {
        if (
          this.choice.itemSort.includes(filter.value) &&
          filter.value !== ""
        )
          filters.push(filter);
      });
      this.optionsType.forEach((filter) => {
        if (this.choice.itemType.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.optionsPrivacy.forEach((filter) => {
        if (this.choice.privacy.includes(filter.value) && filter.value !== "")
          filters.push(filter);
      });
      this.search();
      return filters;
    },
    storageCookies() {
      return this.cookiesPrivacy;
    },
  },
  methods: {
    ...mapActions(["searchAPI"]),
    makeSearch(value) {
      this.filter = value;
    },
    resultCount(count) {
      this.resultNumber = count.length;
    },
    expand() {
      this.isBannerExpanded = true;
    },
    retract() {
      this.isBannerExpanded = false;
    },
    applyFilters(arr) {
      if (this.filter.itemType.length !== 0) {
        arr = arr.filter((item) => {
          return (
            this.filter.itemType.includes(item.type) &&
            this.filter.options.includes(item.class)
          );
        });
      }
      if (this.filter.itemCategory.length !== 0) {
        arr = arr.filter((item) => {
          return (
            this.filter.itemCategory.includes(item.category) &&
            this.filter.options.includes(item.class)
          );
        });
      }
      if (this.filter.itemCondition.length !== 0) {
        arr = arr.filter((item) => {
          return (
            this.filter.itemCondition.includes(item.condition) &&
            this.filter.options.includes(item.class)
          );
        });
      }
      return arr;
    },
    openChat(key) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        key.feedType = "NEW_ITEM";
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
        this.selectedKeyChat.messages = this.selectedKeyChat.messages.filter(
          (msg) => {
            return (
              msg.senderId === key.user.id || msg.receiverId === key.user.id
            );
          }
        );
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$refs.rightStickyBar.openClosePopup();
    },
    joinGroupWarning(warning) {
      this.warning = warning;
      this.warningTitle = "Join group";
      $("#result-warning").modal("show");
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    openTradeModal(itemId) {
      $(`#trade-item-${itemId}`).modal("show");
    },
    accept(a) {
      this.cookiesPrivacy = a;
    },
    async search() {
      let booksResults = [];
      let totalItems = [];
      let i = 0
      for (i=0;i< this.selectedCategories.length;i++){
        let result = await axios.get(Global.getServerDomain() + '/bookmark?query='+this.selectedCategories[i], { headers });
        let totalResult = await axios.get(Global.getServerDomain() + '/totalItems?query='+this.selectedCategories[i], { headers });
        booksResults.push(...result.data);
        totalItems.push(...totalResult.data);
      }
      this.resultCount(booksResults)
      this.booksResults = booksResults;
      this.totalBooksResults.data = totalItems;
    },
    async searchNewResults() {
      let booksResults = [];
      for (let i=0;i< this.selectedCategories.length;i++){
        let result = await axios.get(Global.getServerDomain() + '/scrollFetch?query='+this.selectedCategories[i]+'?'+this.searchOffset, { headers });
        booksResults.push(...result.data);
      }

      this.booksResults.push(...booksResults);
      this.resultCount(this.booksResults)
    },
    changeCategory(value) {
      if (value.itemCategory === 1) {
        this.search(this.categories[6].searchQuery);
      } else if (value.itemCategory === 2) {
        this.search(this.categories[3].searchQuery);
      } else if (value.itemCategory === 3) {
        this.search(this.categories[2].searchQuery);
      } else if (value.itemCategory === 4) {
        this.search(this.categories[7].searchQuery);
      } else if (value.itemCategory === 5) {
        this.search(this.categories[1].searchQuery);
      } else if (value.itemCategory === 6) {
        this.search(this.categories[10].searchQuery);
      } else if (value.itemCategory === 7) {
        this.search(this.categories[11].searchQuery);
      } else if (value.itemCategory === 8) {
        this.search(this.categories[0].searchQuery);
      } else if (value.itemCategory === 9) {
        this.search(this.categories[4].searchQuery);
      } else if (value.itemCategory === 10) {
        this.search(this.categories[5].searchQuery);
      } else if (value.itemCategory === 11) {
        this.search(this.categories[8].searchQuery);
      } else if (value.itemCategory === 12) {
        this.search(this.categories[9].searchQuery);
      }
    },
    clearFilter() {
      this.choice = {
        options: [],
        itemType: [],
        itemCondition: [],
        itemSort: [],
        privacy: [],
        itemCategory: [],
      };
    },
    removeFilter(removed) {
      if (this.options.includes(removed)) {
        this.choice.options = this.choice.options.filter((filter) => {
          return filter !== removed.value;
        });
        if (removed.value === "item") {
          this.choice.itemType = [];
          this.choice.itemCondition = [];
          this.choice.itemCategory = [];
          this.choice.itemSort = [];
        }
        if (removed.value === "group") {
          this.choice.privacy = [];
        }
      } else if (this.optionsType.includes(removed)) {
        this.choice.itemType = this.choice.itemType.filter((filter) => {
          return filter !== removed.value;
        });
      } else if (this.optionsCondition.includes(removed)) {
        this.choice.itemCondition = this.choice.itemCondition.filter(
          (filter) => {
            return filter !== removed.value;
          }
        );
      } else if (this.optionsSort.includes(removed)) {
        this.choice.itemSort = this.choice.itemSort.filter(
          (filter) => {
            return filter !== removed.value;
          }
        );
      } else if (this.optionsPrivacy.includes(removed)) {
        this.choice.privacy = this.choice.privacy.filter((filter) => {
          return filter !== removed.value;
        });
      } else {
        this.choice.itemCategory = this.choice.itemCategory.filter((filter) => {
          return filter !== removed.value;
        });
      }
    },
    checkScrollBottom() {
      let scrolledPage = 0;
      window.onscroll = () => {
        if (window.scrollY - scrolledPage > 4000) {
          scrolledPage = window.scrollY;
          this.searchOffset = this.searchOffset + 48;
          this.searchNewResults();
          this.isBottom = true;
        } else {
          this.isBottom = false;
        }
      };
    },
  },
  watch: {
    
    isBottom(newValue) {
      if (typeof newValue === "boolean") {
        this.commitScrollStatus({ isBottom: newValue });
      }
    },
  },
  async created() {
    this.totalBooksResults = await axios.get(Global.getServerDomain() + '/totalItems?query='+this.selectedCategories[0], { headers });
    this.booksResults = await axios.get(Global.getServerDomain() + '/bookmark', { headers });
    this.resultCount(this.booksResults.data)


    if (this.$route.query.filter) {
      this.startOption.push("item");
      this.startCategory = [parseInt(this.$route.query.filter)];
    }

    const itemId = this.$route.query.sendTradeMessage;
    if (itemId) {
      $(() => {
        this.openTradeModal(itemId);
      });
    }

    const groupId = this.$route.query.askToJoinGroup;
    if (groupId) {
      $(() => {
        const ref = `group-${groupId}`;
        const groupCard = $(`.${ref}`)[0];
        groupCard.scrollIntoView(false);
        this.$refs[ref][0].openModal();
      }).catch(() => console.log("user not logged"));
    }

    const userId = this.$route.query.chatWithUser;
    if (userId) {
      $(() => {
        const ref = `user-${userId}`;
        const usarCard = $(`.${ref}`)[0];
        usarCard.scrollIntoView(false);
        this.$refs[ref][0].tryToOpenChat(userId);
      }).catch(() => console.log("user not logged"));
    }
  },
  updated() {
    $('[data-toggle="tooltip"], [rel="tooltip"]').tooltip();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  // beforeRouteLeave(to, from, next) {
  //   if (
  //     this.isUserAuthenticated ||
  //     this.canRedirect ||
  //     to.path === "/" ||
  //     this.categories.some((category) =>
  //       category.searchQuery.includes(to.path)
  //     ) ||
  //     to.name === "SItemDetailFromLandingPage"
  //   ) {
  //     this.$refs.sfilter.destroy();
  //     next();
  //   } else {
  //     if (to.path !== "/login" && to.name !== "SItemDetailFromLandingPage") {
  //       this.redirectTo = to.fullPath;
  //       $("#confirm-login-redirect").modal("show");
  //     } else {
  //       this.$refs.sfilter.destroy();
  //       next();
  //     }
  //   }
  // },
  async mounted() {
    this.checkScrollBottom();
    if (this.prevRoute.path === "/s-app/item-activity") {
      this.$router.go();
    }
  },
  unmounted() {
    this.style.remove();
  },
};
</script>

<style scoped>
.container {
  margin-top: 100px;
  min-width: 100%;
  padding: 0 50px;
}
.register-button {
  margin: 1rem 0 0.5rem 0;
}
.banner-expand {
  max-height:1000px !important;
}
.show-more-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin: 0.5rem 1rem 0 1rem;
  color: black;
}
.display-none {
  display: none;
}
.bookmark-banner {
  width: 90%;
  min-height: 300px;
  background-image: linear-gradient(#668AAE, white);
  border-radius: 4px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.show-more-dropdown {
  cursor: pointer;
  color: #05919b;
  text-decoration: underline;
  margin: 0.5rem 0;
}
.bookmark-text {
  color: black;
  text-align: center;
  margin: 0.25rem 1rem;
  font-size: 1rem;
}
.link-text {
  text-decoration: underline;
}
#show-more-text p {
  margin-bottom: 0;
  font-size: 1rem;
}
.text-blocks {
  margin: 0.5rem 0;
}
.bookmark-header-text {
  color: black;
  font-weight: bold;
  text-align: center;
  font-size: 24px;
  line-height: 24px;
}
.bookmark-title {
  color: black;
  font-weight: bold;
  text-align: center;
  font-size: 40px;
  line-height: 40px;
  margin-top: 1rem;
}
.item-unavailable {
  filter: grayscale(100%);
}

.card-search-container {
  padding: 0 28px;
}

#search-item-gallery {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between !important;
}
#search-item-gallery > div {
  box-sizing: border-box;
}

.md-layout-item {
  margin: 0 8px 16px !important;
  padding: 0 !important;
  max-width: 576px;
}
</style>

<style lang="scss">
.page-has-left-panels {
  padding-left: 0 !important;
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .bookmark-banner {
    width: 100%;
  }
  .container {
    padding: 0 10px;
  }
}
@media screen and (max-width: 360px) {
  .bookmark-banner {
    min-height: 300px;
  }
  .bookmark-title {
    font-size: 32px;
    line-height: 32px;
  }
  .bookmark-header-text {
    font-size: 24px;
    line-height: 24px;
  }
}
</style>
